








































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class CardModalAlasanBatalOrder extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly id!: string;
  alasan = "";

  saveAlergi() {
    if (this.alasan == "") {
      // console.log("harus isi");
    } else {
      const data = {
        id: this.id,
        alasan: this.alasan
      };
      this.$emit("alasanBatal", data);
      this.show = false;
      this.alasan = "";
    }
  }

  @Watch("")
  close() {
    this.show = false;
    this.alasan = "";
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
}
